"use client";

export default function WhyMaintenance() {
  return (
    <section className="bg-cream py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-[32px] font-bold text-secondary text-center mb-12">
          Why Window Maintenance Matters
        </h2>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
          <div>
            <h3 className="text-xl md:text-[22px] font-bold text-secondary mb-3">
              Salt Air &amp; Humidity
            </h3>
            <p className="text-sm text-gray-600 leading-relaxed">
              Miami coastal climate is brutal on window hardware. Salt air corrodes rollers, locks, hinges 3-5x faster than inland. Annual maintenance catches problems before failure.
            </p>
          </div>
          <div>
            <h3 className="text-xl md:text-[22px] font-bold text-secondary mb-3">
              Cost Prevention
            </h3>
            <p className="text-sm text-gray-600 leading-relaxed">
              A $129 annual tune-up prevents $400-800 repair calls. Most hardware failures we see could have been avoided with regular cleaning and lubrication.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}